import React from 'react';

const Button = props => (
    <button onClick={props.onClick} className={`btn ${props.classes}`} disabled={props.disabled}>
      {props.children}
    </button>
  );

export { Button };
